<template>
    <div class="d-flex align-items-baseline">
        <div class="d-flex align-items-center flex-row">
            <div class="mr-1 sortBy-title text-center d-none d-sm-block">Ordenar por:</div>
            <div>
                <b-form-select
                    v-model="sortBy"
                    :options="sort"
                    @change="onPageSortChange"
                    size="sm"
                    class="sortBy-name"
                    value-field="value"
                ></b-form-select>
            </div>
        </div>
        <div class="align-items-center flex-row d-none d-lg-flex ml-3">
            <div class="mr-1 sortBy-title text-center">Quantidade por página:</div>
            <div>
                <b-form-select
                    v-model="perPage"
                    :options="amount"
                    @change="onPageLimitChange"
                    size="sm"
                    class="sortBy-name"
                    value-field="value"
                ></b-form-select>
            </div>
        </div>
    </div>
</template>
<script>
    import utils from '~/mixins/utils'

    export default {
        mixins: [
            utils
        ],
        props: {
            currentSort: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                sortBy: 'relevance',
                perPage: 12,
                sort: [
                    {
                        text: 'Relevância',
                        value: 'relevance'
                    },
                    {
                        text: 'Menor preço',
                        value: 'price'
                    },
                    {
                        text: 'Maior preço',
                        value: '-price'
                    },
                    {
                        text: 'Nome (A-Z)',
                        value: 'name'
                    },
                    {
                        text: 'Nome (Z-A)',
                        value: '-name'
                    }
                ],
                amount: [
                    {
                        text: '12 produtos',
                        value: 12
                    },
                    {
                        text: '24 produtos',
                        value: 24
                    },
                    {
                        text: '36 produtos',
                        value: 36
                    },
                    {
                        text: '48 produtos',
                        value: 48
                    },
                    {
                        text: '60 produtos',
                        value: 60
                    }
                ],
            }
        },
        mounted() {
            if (this.$route.query.limit) {
                if (this.perPageIsValid(this.$route.query.limit)) {
                    this.perPage = this.$route.query.limit
                    // sessionStorage.setItem('per_page', this.perPage);
                }
            }
            // if (sessionStorage.getItem('per_page')) {
            //     const limit = this.amount.find(el => {
            //         return el.value == sessionStorage.getItem('per_page')
            //     })
            //     if (limit) {
            //         this.perPage = sessionStorage.getItem('per_page')
            //         sessionStorage.setItem('per_page', this.perPage);
            //     }
            // }
            if (this.$route.query.sort) {
                const sort = this.sort.find(el => {
                    return el.value == this.$route.query.sort
                })
                if (sort) {
                    this.sortBy = this.$route.query.sort
                }
            }
            if (this.currentSort) {
                const sort = this.sort.find(el => el.value == this.currentSort)
                if (sort) {
                    this.sortBy = this.currentSort
                }
            }
        },
        methods: {
            perPageIsValid(value) {
                return this.amount.find(el => {
                    return el.value == value
                })
            },
            onPageSortChange(value) {
                if (value) {
                    this.query({sort: value}, ['page'])
                } else {
                    this.query({}, ['page', 'sort'])
                }
            },
            onPageLimitChange(value) {
                if (this.perPageIsValid(value)) {
                    // this.$emit('pageLimitChange', value)
                    this.query({limit: value}, ['page'])
                }
            }
        }
    }
</script>
